import { render } from "./TestItemPage.vue?vue&type=template&id=ace0239a"
import script from "./TestItemPage.vue?vue&type=script&lang=js"
export * from "./TestItemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/DashBoard/TestItemPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ace0239a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ace0239a', __exports__)) {
    api.reload('ace0239a', __exports__)
  }
  
  module.hot.accept("./TestItemPage.vue?vue&type=template&id=ace0239a", () => {
    api.rerender('ace0239a', render)
  })

}


export default __exports__